module.exports = {"title":"6. Pour aller plus loin","read":"Lire la suite"};